// extracted by mini-css-extract-plugin
export default {"label":"Label_label__WYVoN","success":"Label_success__lDBbI","error":"Label_error__I9qa6","warning":"Label_warning__1gBvh","info":"Label_info__WRXEk"};